<div class="drill-down-main-container">
    <div class="categories-main-container">
        <p-carousel
            [value]="categoryList"
            [page]="pageOfCurrentCategory"
            [numVisible]="1"
            [numScroll]="1"
            [showIndicators]="false">
            <ng-template pTemplate="item" let-item>
                {{item.title}}
            </ng-template>
        </p-carousel>
    </div>
    <div class="statements-main-container">
        <h2>Statements</h2>
        <div class="filters-container">

        </div>
    </div>
</div>
